<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-8rem)] overflow-y-auto">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Fechamento de Caixa</h2>
    
    <div class="space-y-4">
      <div class="bg-gray-50 p-4 rounded-md">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-gray-700">Valores Recebidos no Turno</h3>
          <div class="flex items-center gap-2">
            <span class="text-sm font-medium text-gray-600">Total:</span>
            <span class="text-xl font-bold text-green-600">{{ totalReceived | currency:'BRL' }}</span>
          </div>
        </div>
        
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Dinheiro</label>
            <p-inputNumber 
              [(ngModel)]="moneyReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">PIX</label>
            <p-inputNumber 
              [(ngModel)]="pixReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Cartão de Crédito</label>
            <p-inputNumber 
              [(ngModel)]="creditCardReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Cartão de Débito</label>
            <p-inputNumber 
              [(ngModel)]="debitCardReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Cheque</label>
            <p-inputNumber 
              [(ngModel)]="checkReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Crédito</label>
            <p-inputNumber 
              [(ngModel)]="creditReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Transferência Bancária</label>
            <p-inputNumber 
              [(ngModel)]="bankTransferReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Vale</label>
            <p-inputNumber 
              [(ngModel)]="voucherReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Depósito</label>
            <p-inputNumber 
              [(ngModel)]="depositReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">Cashback</label>
            <p-inputNumber 
              [(ngModel)]="cashBackReceived"
              [min]="0"
              [max]="999999.99"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              currency="BRL"
              locale="pt-BR"
              class="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Botões de Ação -->
    <div class="flex justify-end space-x-4 mt-6">
      <button 
        (click)="goBack()"
        pButton
        type="button"
        label="ESC - Voltar"
        class="p-button-secondary">
      </button>
      <button 
        (click)="confirmClosure()"
        pButton
        type="button"
        label="F1 - Confirmar Fechamento"
        class="p-button-danger">
      </button>
    </div>
  </div>
</div>
